module.exports = __webpack_public_path__ + "ipetbooking/admin/img/pet-avatar-default@2x.5eaf0385.png";